import { render, staticRenderFns } from "./uploadAndDownload.vue?vue&type=template&id=4069fb76&"
import script from "./uploadAndDownload.vue?vue&type=script&lang=js&"
export * from "./uploadAndDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports